// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2CZs9","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__32JnR"};